import { render, staticRenderFns } from "./ListDelete.vue?vue&type=template&id=8081ff8e&scoped=true&"
import script from "./ListDelete.vue?vue&type=script&lang=js&"
export * from "./ListDelete.vue?vue&type=script&lang=js&"
import style0 from "./ListDelete.vue?vue&type=style&index=0&id=8081ff8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8081ff8e",
  null
  
)

export default component.exports